/**
 * Styled Components - Created by david on 28/02/18.
 */
import styled, { css } from 'styled-components'
import { GRAY_DARK, RED, BLUE_BRIGHT, RED_LIGHT, RED_SOFT } from '../../theme/colors'
import Button from 'antd/lib/button'

export const Container = styled.div``

export const ContainerCard = styled.div`
  border-bottom: 1px solid #f2f2f2;
  margin-top: 10px;
  border-radius: 5px;
  padding: 6px 10px;
  padding-bottom: 0;
  margin-right: 10px;
  margin-left: 10px;
  background: #f4f4f4;
  @media (min-width: 1700px) {
    max-width: 512px;
    margin: 0 auto;
    margin-top: 10px;
  }
`

interface StyledProps {
  myFilesList?: boolean
}

interface OvalProps {
  currentColor?: string
}

export const ColorButtons = styled.div`
  display: flex;
  justify-content: ${({ myFilesList }: StyledProps) =>
    !myFilesList ? 'space-around' : 'space-between'};
  padding: ${({ myFilesList }: StyledProps) =>
    !myFilesList ? '14px 32px 0px 32px' : '14px 0'};

  @media (min-width: 768px) and (max-width: 991px) {
    ${({ myFilesList }: StyledProps) =>
      !myFilesList
        ? css`
            flex-wrap: wrap;
            padding: 20px 0px 10px 18px;
          `
        : ''};
  }
`

export const Name = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  ${({ myFilesList }: StyledProps) =>
    !myFilesList ? '' : 'font-weight: 600;'};
  line-height: 23px;
`

export const Row = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-left: 6px;
`
export const deleteIcon = {
  color: RED,
  fontSize: 18
}

export const Delete = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-left: 8px;
`
export const TopRow = styled.div`
  align-items: center;
  display: flex;
`

export const buttonStyle = {
  backgroundColor: BLUE_BRIGHT,
  borderColor: BLUE_BRIGHT,
  height: '22px',
  fontSize: '12px',
  padding: '0 12px'
}

export const MyFilesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 24px 0;
`

export const DeleteText = styled.div`
  color: ${RED};
  cursor: pointer;
  font-size: 14px;
  letter-spacing: 0.1px;
  line-height: 23px;
`

export const DeleteButton = styled(Button)`
  padding: 0 12px;
  height: 26px;

  @media (max-width: 767px) {
    color: ${RED_LIGHT};
    border-color: ${RED_SOFT};
  }
`

export const ColorContainer = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
`

export const Text = styled.div`
  color: #5f6062;
  font-size: 12px;
  line-height: 16px;
  margin-top: 12px;
`

export const Oval = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  border: 1px ${({ currentColor }: OvalProps) => currentColor === '' ? 'dashed' : 'solid'}
    ${({ currentColor }: OvalProps) =>
      currentColor && currentColor.toLowerCase() !== '#ffffff'
        ? currentColor
        : '#bebebe'};
  background-color: ${({ currentColor }: OvalProps) => currentColor || '#fff'};
  align-self: center;
`

export const OvalSelected = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #fff;
  align-self: center;
`

export const ColorCard = styled.div`
  background: white;
  overflow: hidden;
  box-shadow: 1px 1px 3px -1px gray;
  border-radius: 5px;
  max-width: 96px;
  min-width: 68px;
  width: 100%;
  display: flex;
  flex-flow: column;
  margin-right: 8px;
  &:last-child {
    margin-right: 0px;
  }
`

export const ColorCardsRow = styled.div`
  display: flex;
  margin: 0 auto;
  margin-top: 8px;
  margin-bottom: 6px;
  width: fit-content;
`

export const CardColor = styled.div`
  height: 32px;
  max-width: 96px;
  width: 100%;
  border-bottom: 1px solid #ebebeb;
  border-top: 1px solid #f1f1f1;
  background-color: ${({ currentColor }: OvalProps) => currentColor || '#fff'};
`

export const TextCard = styled.div`
  white-space: pre-wrap;
  font-size: 10px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 4px;
  margin-left: 4px;
  margin-right: 4px;
`

export const AppliedLabel = styled.div`
  font-size: 12px;
  padding: 1px 8px;
  background: #d7f0d8;
  border-radius: 3px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/PaletteCard/styledComponents.tsx